import type { RefObject } from 'react';

import type { Overlay } from './types.js';

const NullPositions = {
  absoluteX: null,
  absoluteY: null,
  relativeX: null,
  relativeY: null,
  percentX: null,
  percentY: null,
};
function getAdjustedPositionsFromAbsolute(
  this: { getBounds: Overlay['getBounds'] },
  absoluteX: number,
  absoluteY: number,
) {
  const bounds = this.getBounds();
  if (!bounds) {
    return NullPositions;
  }

  const { left, top, width, height } = bounds;
  const relativeX = Math.round(absoluteX - left);
  const relativeY = Math.round(absoluteY - top);
  const percentX = Math.round((relativeX * 100) / width);
  const percentY = Math.round((relativeY * 100) / height);

  return {
    absoluteX,
    absoluteY,
    relativeX,
    relativeY,
    percentX,
    percentY,
  };
}

function getAdjustedPositionsFromPercent(
  this: { getBounds: Overlay['getBounds'] },
  percentX: number,
  percentY: number,
  relativeX?: number,
  relativeY?: number,
) {
  const bounds = this.getBounds();
  if (!bounds) {
    return NullPositions;
  }

  const { left, top, width, height } = bounds;
  relativeX ||= Math.round((percentX * width) / 100);
  relativeY ||= Math.round((percentY * height) / 100);
  const absoluteX = Math.round(left + relativeX);
  const absoluteY = Math.round(top + relativeY);

  return {
    absoluteX,
    absoluteY,
    relativeX,
    relativeY,
    percentX,
    percentY,
  };
}

function getAdjustedPositionsFromRelative(
  this: { getBounds: Overlay['getBounds'] },
  relativeX: number,
  relativeY: number,
) {
  const bounds = this.getBounds();
  if (!bounds) {
    return NullPositions;
  }

  const { left, top, width, height } = bounds;
  const percentX = Math.round((relativeX * 100) / width);
  const percentY = Math.round((relativeY * 100) / height);
  const absoluteX = Math.round(left + relativeX);
  const absoluteY = Math.round(top + relativeY);

  return {
    absoluteX,
    absoluteY,
    relativeX,
    relativeY,
    percentX,
    percentY,
  };
}
export function buildOverlay(
  overlayRef: RefObject<HTMLDivElement | undefined>,
): Overlay {
  let bounds: DOMRect | undefined = undefined;

  return {
    overlayRef: overlayRef as RefObject<HTMLDivElement>,
    getBounds() {
      bounds ||= overlayRef.current?.getBoundingClientRect();
      return bounds;
    },
    getAdjustedPositionsFromAbsolute,
    getAdjustedPositionsFromPercent,
    getAdjustedPositionsFromRelative,
    clear() {
      bounds = undefined;
    },
  };
}
